var $resultsEl = $('#results');
var setupActiveFilters = function(){
  // we don't have a good way to modify the tag link output, so inject an icon when active
  $('.options .active a').append(window.closeIcon);
};
var updateToolbarDom = function(){
  let $toolbar = $('#collection-tools .container');
  let $expandingPanel = $('#expandable-tools');
  let $filters = $('.filters');

  if ( !$toolbar.length ) return;

  if ($w.width() < app.breakpoints.lg) {
    if (!$expandingPanel.find('.filters').length) {
      $filters.detach().appendTo($expandingPanel);
    }
  } else {
    if (!$toolbar.children('.filters').length) {
      $filters.detach().appendTo($toolbar);
    }
  }
};
var getSwatchMarkup = function(value){
  let handle = value.split(' ').join('-');
  handle = handle.replace('®', '').replace('™', '').toLowerCase();
  return '<i class="swatch" style="background-image: url(' + holster_finder_cdn_url + 'swatch-' + handle + '.png"></i>';
};
var getHolsterSwatches = function(){
  var handles = [];
  $('.product-item').each(function(){
    // we don't need to do this for regular products
    if (!$(this).hasClass('is-holster')) {
      return;
    }
    // bail if we don't have the handle for some reason
    if (!$(this).data('handle')) {
      return;
    }
    // swatches aren't shown in product sliders
    if ($(this).closest('.product-slider').length) {
      return;
    }
    handles.push($(this).data('handle'));
  });

  if( !handles.length ) return;

  $.ajax({
    url: window.apiHost + '/holsters/colors',
    method: 'POST',
    data: {
      'urls' : handles.join(',')
    },
    success: function(data){
      // data returned as {product-handle-1: [color 1,color 2], product-handle-2: [color 1,color 2]}
      let handles = Object.keys(data);
      if (handles.length) { // make sure we got a response
        for (const handle of handles){
          if( data[handle].length > 1 ){ // skip single swatches
            $(`[data-handle="${handle}"] .swatches`).html('');
            data[handle].forEach(color => {
              $(`[data-handle="${handle}"] .swatches`).append(getSwatchMarkup(color));
            });
          }
        }
      }
    },
    error: function(jqXHR, textStatus, errorThrown){
      console.log(errorThrown);
    }
  });
};

updateToolbarDom();
setupActiveFilters();

// AJAX-ify toolbars
$b.on('click', '.toolbar a, #expandable-tools a, #collection-status-bar a', function(e){
  e.preventDefault();
  let $this = $(this);
  let url = $this.attr('href');
  if (url === '#') {
    return; // a trigger, not a link
  }
  $resultsEl.addClass('working');
  $.ajax({
    url: url,
    success: function(data){
      $resultsEl.html($(data).find('#results').html());
      $resultsEl.find('.btn-enhanced').append(window.app.btnBorder);
      $resultsEl.removeClass('working');
      if ($this.hasClass('pagination-link')) {
        $w.scrollTop($resultsEl.offset().top - $('#navbar').outerHeight());
      }
      updateToolbarDom();
      setupActiveFilters();
      sessionStorage.setItem($resultsEl.data('id'),$resultsEl.html());
      getHolsterSwatches();
    },
    error: function(jqXHR, textStatus, errorThrown){
      console.log(textStatus,errorThrown);
    }
  });
});
// Restore previous state when returning to collection
if ($resultsEl.length && sessionStorage.getItem($resultsEl.data('id'))) {
  $resultsEl.html(sessionStorage.getItem($resultsEl.data('id')));
  getHolsterSwatches();
  updateToolbarDom();
}

$w.on('resize', function(){
  updateToolbarDom();
});

$b.on('click', '#expandable-toggle', function(e){
  e.preventDefault();
  let $target = $('#expandable-tools');
  $(this).toggleClass('is-open');
  if ($(this).hasClass('is-open')) {
    $target.show();
  } else {
    $target.hide();
  }
});

getHolsterSwatches();